// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o0-1";
export var messageSideRight = "_o0-2";
export var orderLookupBubbleContainer = "_o0-0";
export var submitButton = "_o0-3";